/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TMessagesReadRequest,
  TMessagesReadModel,
  IMappers,
  TMessagesReadResponse,
  TMessagesReadResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createMessagesReadModel(parameters: TMessagesReadRequest): TMessagesReadModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/messages/read/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IMessagesReadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TMessagesReadRequest;
}

export async function fetchMessagesRead<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IMessagesReadOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TMessagesReadResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createMessagesReadModel(parameters),
    config,
  )) as FetchResponse<TMessagesReadResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TMessagesReadResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TMessagesReadResponse>;
}
